<template>
  <div
    class="playersCarousel"
    ref="playersCarousel"
    v-if="onlinePlayers && onlinePlayers.length > 0"
  >
    <div class="is-flex is-justify-content-space-between is-align-items-center">
      <span class="has-text-info-dark has-text-left	">
        ONLINE PLAYERS: {{ onlinePlayers.length }}
      </span>

      <DelayedInput
        class="is-flex-grow-1 ml-5"
        v-model="filterName"
        type="search"
        icon="search"
        placeholder="Type to search online players"
      />
    </div>

    <p
      style="margin-top: 1rem; color: darkred;"
      v-show="filterName && filterName !== '' && carouselItems.length < 1"
    >
      No player found with
      <strong>"{{ filterName }}"</strong>
      name.
    </p>
    <div class="carousel__container">
      <b-carousel-list
        v-for="i in rowsToShow"
        :key="`carousel${i}`"
        v-model="carouselIndexes[i]"
        :items-to-show="itemsToShow"
        :items-to-list="itemsToShow"
        :data="
          carouselItems.slice(
            (i - 1) * Math.floor(itemsToShow),
            rowsToShow === 1
              ? carouselItems.length
              : i * Math.floor(itemsToShow)
          )
        "
      >
        <template #item="player">
          <div ref="carousel__item" @click="handleClick(i, player.index)">
            <ProfileCard
              :player="player"
              :type="cardType"
              :isSquared="true"
              :onlinePlayer="player"
              :challenge="true"
            />
          </div>
        </template>
      </b-carousel-list>
    </div>
  </div>
  <div v-else>
    <b-notification type="is-link" class="is-light" :closable="false">
      No other player is online at the moment.
    </b-notification>
  </div>
</template>

<script>
import ProfileCard from "@/components/players/ProfileCard.vue";
import { EventBus } from "@/services/event-bus";
import DelayedInput from "../DelayedInput";
import { ONLINE_STATUS } from "../../constants";

export default {
  name: "PlayersCarousel",
  components: {
    DelayedInput,
    ProfileCard,
  },

  props: ["onlinePlayers", "cardType", "cardSize", "rows"],

  data() {
    return {
      carouselIndexes: [],
      width: 400,
      itemsToShow: 4,
      filterName: null,
      carouselItems: [],
      lastRefeshTime: null,
      lastUpdateTime: null,
    };
  },

  computed: {
    rowsToShow() {
      if (!this.carouselItems || !this.carouselItems.length) return 0;
      const maxRows = this.rows ? this.rows : 1;
      return Math.min(
        maxRows,
        1 + Math.floor(this.carouselItems.length / this.itemsToShow)
      );
    },
  },

  watch: {
    filterName: function() {
      this.refreshCarouselItems();
    },

    onlinePlayers: {
      immediate: true,
      handler() {
        this.refreshCarouselItems();
      },
    },
  },

  methods: {
    onResize() {
      if (!this.$refs.playersCarousel) return;
      this.width = this.$refs.playersCarousel.clientWidth;
      this.itemsToShow = this.width / (this.cardSize + 2 * 2); //2 borders of 2px
    },

    handleClick(rowIndex, playerIndex) {
      this.carouselIndexes[rowIndex] =
        playerIndex - (rowIndex - 1) * this.itemsToShow;
    },

    handleChallenge(player) {
      EventBus.$emit("onChallenge", player);
    },

    refreshCarouselItems() {
      if (!this.onlinePlayers || !this.onlinePlayers.length) {
        this.carouselItems = [];
        return;
      }

      let elapsed = this.lastUpdateTime
        ? Date.now() - this.lastUpdateTime
        : 99999999;

      let onlinePlayers = this.onlinePlayers.filter((player) =>
        [
          ONLINE_STATUS.ACTIVE,
          ONLINE_STATUS.AWAY,
          ONLINE_STATUS.BUSY,
          ONLINE_STATUS.PLAYING,
        ].includes(player.status)
      );

      if (this.filterName) {
        onlinePlayers = onlinePlayers.filter((player) =>
          player.name.toLowerCase().includes(this.filterName.toLowerCase())
        );
      }

      elapsed = this.lastRefeshTime
        ? Date.now() - this.lastRefeshTime
        : 99999999;
      if (elapsed > 8000 || !this.carouselItems.length) {
        this.carouselItems = onlinePlayers
          .sort((p1, p2) =>
            p1.status > p2.status
              ? 1
              : p1.status < p2.status
              ? -1
              : p2.updatedAt - p1.updatedAt
          )
          .slice(0, 18)
          .map((player, i) => ({
            ...player,
            index: i,
          }));
        this.lastRefeshTime = Date.now();
        this.lastUpdateTime = Date.now();
        return;
      }

      const carouselItems = this.carouselItems.map((player, i) => {
        const newP = onlinePlayers.find((p) => p.username == player.username);
        if (newP) return { ...newP, index: i };
        player.status = ONLINE_STATUS.OFFLINE;
        return player;
      });
      if (carouselItems.length < Math.min(20, onlinePlayers.length)) {
        carouselItems.push(
          ...onlinePlayers
            .filter(
              (p) => !carouselItems.find((p1) => p1.username == p.username)
            )
            .slice(0, 18 - carouselItems.length)
        );
      }
      this.carouselItems = carouselItems;
      this.lastUpdateTime = Date.now();
    },
  },

  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
      this.onResize();
    });
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
};
</script>

<style scoped></style>
